import numeral from 'numeral';
import moment from 'moment';

export function classNames(...classes: string[]): string {
  return classes.filter(Boolean).join(' ');
}
export function getTimePart(start_time: string) {
  return start_time.split('T')[1].split('+')[0];
}
export const scrollTo = (id: string) => {
  const element = document.getElementById(id);

  if (element) {
    // Smooth scroll to that elment
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start',
    });
  }
};

export const countTotalPrice = (product: any, deliveryFee: string) => {
  let total = 0;
  let totalAmount = 0;
  product.map((val) => {
    total = total + parseFloat(val.quantity) * parseFloat(val.price);
  });

  if (deliveryFee) {
    totalAmount = total + parseFloat(deliveryFee);
  } else {
    totalAmount = total;
  }

  return {
    totalAmount: numeral(totalAmount).format('0,00.00'),
    totalPrice: numeral(total).format('0,00.00'),
  };
};

export const countTotal = (product: any) => {
  let totalWeight = 0;
  let totalVolume = 0;
  if (product.length > 0) {
    product.map((val) => {
      totalWeight =
        parseFloat(val.weight) * parseFloat(val.quantity) + totalWeight;
      totalVolume =
        parseFloat(val.volume) * parseFloat(val.quantity) + totalVolume;
    });
    return {
      totalWeight: numeral(totalWeight).format('0,00.00'),
      totalVolume: numeral(totalVolume).format('0,00.00'),
    };
  } else {
    return { totalWeight: 0, totalVolume: 0 };
  }
};

export const yearFormating = (date: string) => {
  const split = date.split('/').map(function (item) {
    return item.trim();
  });

  const newDate = split[0] + '/20' + split[1];
  return newDate;
};

export const cardFormating = (date: string) => {
  if (date) {
    const dateData = moment(date);
    const yearComponent = dateData.utc().format('YY');
    const montComponent = dateData.utc().format('MM');

    return montComponent + '/' + yearComponent;
  }
};

/**
 * Converts a hex color to an RGBA color with the given opacity.
 * @param hex - The hex color code (e.g., "#ff5733").
 * @param opacity - The opacity level (0 to 1).
 * @returns The RGBA color code.
 */
export function hexToRgba(hex: string, opacity: number): string {
  if (hex.startsWith('#')) {
    hex = hex.slice(1);
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

/**
 * Darkens a hex color by a given amount.
 * @param hex - The hex color code (e.g., "#ff5733").
 * @param amount - The amount to darken (can be negative for lightening).
 * @returns The darkened hex color code.
 */
export function darkenColor(hex: string, amount: number): string {
  if (hex.startsWith('#')) {
    hex = hex.slice(1);
  }

  const num = parseInt(hex, 16);
  let r = (num >> 16) + amount;
  let b = ((num >> 8) & 0x00ff) + amount;
  let g = (num & 0x0000ff) + amount;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return `#${(g | (b << 8) | (r << 16)).toString(16).padStart(6, '0')}`;
}
